import { render, staticRenderFns } from "./PackagePage.vue?vue&type=template&id=5a24b13f&scoped=true&"
import script from "./PackagePage.vue?vue&type=script&lang=js&"
export * from "./PackagePage.vue?vue&type=script&lang=js&"
import style0 from "./PackagePage.vue?vue&type=style&index=0&id=5a24b13f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24b13f",
  null
  
)

export default component.exports